import React, { useCallback, useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CSmartTable,
  CDropdownItem,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
} from '@coreui/react-pro'
import { toast } from 'react-toastify'

import Table from '../TeamPlayer/Table.js'

import moment from 'moment'
import Bootbox from 'bootbox-react'
import { Link, useNavigate } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent.js'
import FixtureService from 'src/service/FixtureService'
import CommonService from 'src/service/CommonService'
import Pusher from 'pusher-js'
import Loader from 'src/components/Loader'
import FixtureSquadTable from './FixtureSquadTable.js'

const ManageFixture = (props) => {
  const [loading, setLoading] = useState(true)
  const [loader, setLoader] = useState(true)
  const [loaderText, setLoaderText] = useState(true)
  const [pageLoading, setPageLoading] = useState(false)

  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState({})
  const [squadFixtureIds, setSquadFixtureIds] = useState([])
  const [inProgressFixture, setInProgressFixture] = useState([])
  const navigate = useNavigate()
  const [gameType, setGameType] = useState()
  useEffect(() => {
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })
  }, [])

  // Delete Fixture code started here
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])

  const toggleAllCheckboxes = () => {
    const allIds = squadFixtureIds.map((user) => user.id)
    setSelectedCheckboxes((prevSelected) => (prevSelected.length === allIds.length ? [] : allIds))
  }
  var columns = [
    {
      key: 'delete_fixture',
      label: (
        <input
          type="checkbox"
          name="delete_all"
          // checked={selectedCheckboxes.length === squadFixtureIds.length}
          checked={
            selectedCheckboxes.length === squadFixtureIds.length && squadFixtureIds.length > 0
          }
          onChange={toggleAllCheckboxes}
        />
      ),
      filter: false,
      sorter: false,
    },
    {
      label: 'FID',
      key: 'id',
      _style: { width: '10%' },
    },
    {
      key: 'round',
    },
    {
      label: 'Team Name',
      key: 'team_name',
    },
    { label: 'Match Type', key: 'match_type', filter: false, sorter: false },
    { label: 'Start Date', filter: false, key: 'start_date' },
    { label: 'Start Time', filter: false, key: 'start_time' },
    { label: 'Status', filter: false, key: 'status' },
    {
      key: 'show_details',
      label: 'Actions',
      filter: false,
      sorter: false,
    },
  ]

  if (gameType !== 1) {
    columns = [
      {
        key: 'delete_fixture',
        label: (
          <input
            type="checkbox"
            name="delete_all"
            // checked={selectedCheckboxes.length === squadFixtureIds.length}
            checked={
              selectedCheckboxes.length === squadFixtureIds.length && squadFixtureIds.length > 0
            }
            onChange={toggleAllCheckboxes}
          />
        ),
        filter: false,
        sorter: false,
      },
      {
        label: 'FID',
        key: 'id',
        _style: { width: '10%' },
      },
      {
        key: 'round',
      },
      {
        label: 'Home Team',
        key: 'team_name',
      },
      {
        label: 'Away Team',
        key: 'team2_name',
      },
      { label: 'Match Type', key: 'match_type', filter: false, sorter: false },
      { label: 'Start Date', filter: false, key: 'start_date' },
      { label: 'Start Time', filter: false, key: 'start_time' },
      { label: 'Status', filter: false, key: 'status' },
      {
        key: 'show_details',
        label: 'Actions',
        filter: false,
        sorter: false,
      },
    ]
  }
  const fetchUsers = useCallback(async () => {
    setLoader(false)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await FixtureService.getFixture(offset, itemsPerPage, activePage, params)
      const squadResult = await FixtureService.getSquadFixture()
      const inProgressFixtureResult = await FixtureService.getInProgressFixture()
      setUsers(result.data)
      setSquadFixtureIds(squadResult.data)
      setInProgressFixture(inProgressFixtureResult.data)
      if (inProgressFixtureResult.data && inProgressFixtureResult.data != null) {
        setLoader(true)
        setLoaderText(inProgressFixtureResult?.message)
      }
    } catch (error) {
      console.error('Error fetching users:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  const toggleCheckbox = (id) => {
    setSelectedCheckboxes((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((selectedId) => selectedId !== id)
      } else {
        return [...prevSelected, id]
      }
    })
  }

  // Delete All confirm box
  const [showDeleteAllConfirm, showShowDeleteAllConfirm] = useState(false)
  const showDeleteAllCofirmBox = () => {
    showShowDeleteAllConfirm(true)
  }
  const handleDeleteAllConfirm = () => {
    handleDeleteAllFixture()
    return showShowDeleteAllConfirm(false)
  }
  const handleDeleteAllCancel = () => {
    console.log('You clicked No!')
    return showShowDeleteAllConfirm(false)
  }
  const handleDeleteAllFixture = () => {
    const data = {
      fixturesIds: selectedCheckboxes, // Include the array of IDs here
    }
    FixtureService.deleteAllFixture(data).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
        setLoading(false)
        fetchUsers()
      }
    })
  }
  useEffect(() => {
    const pusher = new Pusher('2604209a1a0fdaa07dfc', {
      cluster: 'ap4',
    })
    const channel = pusher.subscribe('test-channel')
    channel.bind('test-event', (data) => {
      ToastComponent(data.message, 'red_error')
      fetchUsers()
    })

    const fixtureCompletionChannel = pusher.subscribe('fixture-completion-channel')
    fixtureCompletionChannel.bind('fixture-completion-event', (data) => {
      ToastComponent(data.message, 'success')
      fetchUsers()
    })
    return () => {
      // Unbind events and unsubscribe from channels
      channel.unbind_all()
      channel.unsubscribe()
      fixtureCompletionChannel.unbind_all()
      fixtureCompletionChannel.unsubscribe()
    }
  }, [fetchUsers])

  const redirectPage = (id, teamId) => {
    window.location.href = `/scorecard/${id}/${teamId}`
  }

  // show squad players
  const [pickedPlayer, setPickedPlayer] = useState([])
  const [individualPlayerDisplay, setIndividualPlayerDisplay] = useState('')
  const [teamId, setTeamId] = useState(0)
  const [teamName, setTeamName] = useState(0)
  const [fixtureId, setFixtureId] = useState(0)
  const [showSquadModal, setShowSquadModal] = useState(false)
  const showSquadPlayer = (fixtureId, teamId, teamName) => {
    setTeamId(teamId)
    setFixtureId(fixtureId)
    setShowSquadModal(true)
    setTeamName(teamName)
  }
  const closeSquadModal = () => {
    setShowSquadModal(false)
  }

  return loader ? (
    <Loader loaderText={loaderText} />
  ) : (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
        <div>
          <h4 className="mb-1">Fixtures</h4>
          <div className="text-medium-emphasis">Manage match scores and squads for this round.</div>
        </div>
        <div className="d-flex flex-wrap gap-2">
          <CButton
            color="danger"
            onClick={showDeleteAllCofirmBox}
            disabled={selectedCheckboxes.length === 0}
          >
            Delete All
          </CButton>
        </div>
      </div>

      <CCard>
        <CCardBody>
          <CSmartTable
            columns={columns}
            columnFilter={{
              external: true,
            }}
            columnSorter={{
              external: true,
            }}
            scopedColumns={{
              delete_fixture: (item) => {
                const fixtureIdExists = squadFixtureIds.some((fixture) => fixture.id === item.id)
                return (
                  <th>
                    {fixtureIdExists && (
                      <input
                        type="checkbox"
                        name="delete"
                        value={item.id}
                        checked={selectedCheckboxes.includes(item.id)}
                        onChange={() => toggleCheckbox(item.id)}
                      />
                    )}
                  </th>
                )
              },
              round: (item) => <td>{item.round ?? '-'}</td>,
              team_name: (item) => (
                <td>
                  {' '}
                  <Link
                    onClick={(e) => {
                      e.preventDefault()
                      showSquadPlayer(item.id, item.team, item.team_name)
                    }}
                  >
                    {item.team_name ?? '-'}
                  </Link>
                </td>
              ),
              team2_name: (item) => (
                <td>
                  {' '}
                  <Link
                    onClick={(e) => {
                      e.preventDefault()
                      showSquadPlayer(item.id, item.team2, item.team2_name)
                    }}
                  >
                    {item.team2_name ?? '-'}
                  </Link>
                </td>
              ),
              status: (item) => (
                <td>
                  {item.status === 0 && <CBadge color="warning">Not Started</CBadge>}
                  {item.status === 1 && <CBadge color="danger">In-Progress</CBadge>}
                  {item.status === 2 && <CBadge color="success">Completed</CBadge>}
                  {item.status === 3 && <CBadge color="danger">Failed</CBadge>}
                  {item.status === 4 && <CBadge color="danger">In-Queue</CBadge>}
                </td>
              ),
              grade: (item) => <td>{item.grade ?? ''}</td>,
              start_date: (item) => <td>{moment(item.start_date).format('D.MM.YYYY')}</td>,
              start_time: (item) => <td> {moment(item.start_time, ['HH:mm']).format('h:mm A')}</td>,
              show_details: (item) => {
                return (
                  <>
                    <td className="py-2">
                      {gameType !== 1 && gameType !== 4 && (
                        <>
                          <CDropdown variant="btn-group">
                            <CDropdownToggle color="success">Create Squad</CDropdownToggle>
                            <CDropdownMenu>
                              <CDropdownItem
                                href={`/manage-scores/team-players/${item.id}/${item.team}`}
                              >
                                {item?.team_name}
                              </CDropdownItem>
                              <CDropdownItem
                                href={`/manage-scores/team-players/${item.id}/${item.team2}`}
                              >
                                {item?.team2_name}
                              </CDropdownItem>
                            </CDropdownMenu>
                          </CDropdown>
                          &nbsp;
                          <CDropdown variant="btn-group">
                            <CDropdownToggle color="info">Manage Scores</CDropdownToggle>
                            <CDropdownMenu>
                              <CDropdownItem href={`/team-scorecard/${item.id}/${item.team}`}>
                                {item?.team_name}
                              </CDropdownItem>
                              <CDropdownItem href={`/team-scorecard/${item.id}/${item.team2}`}>
                                {item?.team2_name}
                              </CDropdownItem>
                              <CDropdownItem href={`/full-scorecard/${item.id}`}>
                                Full Scorecard
                              </CDropdownItem>
                            </CDropdownMenu>
                          </CDropdown>
                        </>
                      )}

                      {(gameType === 1 || gameType === 4) && (
                        <>
                          <Link
                            size="sm"
                            className="btn btn-success btn-sm ms-1"
                            to={`/manage-scores/team-players/${item.id}/${item.team}`}
                          >
                            Create Squad
                          </Link>

                          <Link
                            size="sm"
                            className="btn btn-success btn-sm ms-1"
                            onClick={() => redirectPage(item.id, item.team)}
                          >
                            Manage Scores
                          </Link>
                        </>
                      )}
                    </td>
                  </>
                )
              },
            }}
            items={users?.data}
            itemsPerPage={itemsPerPage}
            itemsPerPageSelect
            loading={loading}
            pagination={{
              external: true,
            }}
            paginationProps={{
              activePage: activePage,
              pages: Math.ceil(users?.total / itemsPerPage) || 1,
            }}
            tableProps={{
              hover: true,
              responsive: true,
            }}
            onActivePageChange={(activePage) => setActivePage(activePage)}
            onColumnFilterChange={(filter) => {
              setActivePage(1)
              setColumnFilter(filter)
            }}
            onItemsPerPageChange={(itemsPerPage) => {
              setActivePage(1)
              setItemsPerPage(itemsPerPage)
            }}
            onSorterChange={(sorter) => setColumnSorter(sorter)}
          />
        </CCardBody>
      </CCard>

      <FixtureSquadTable
        pickedPlayer={pickedPlayer}
        setIndividualPlayerDisplay={setIndividualPlayerDisplay}
        individualPlayerDisplay={individualPlayerDisplay}
        teamId={teamId}
        fixtureId={fixtureId}
        gameType={gameType}
        visible={showSquadModal}
        teamName={teamName}
        onClose={closeSquadModal}
      />
      <Bootbox
        show={showDeleteAllConfirm}
        type={'confirm'}
        message={'Are you sure you want to delete all fixtures?'}
        onSuccess={handleDeleteAllConfirm}
        onCancel={handleDeleteAllCancel}
        onClose={handleDeleteAllCancel}
      />
    </>
  )
}

export default ManageFixture
